export default __webpack_public_path__ + "static/media/calendar.96af681c.svg";